import { v4 as uuid } from 'uuid'

export const arrayUID = array => {
  if (!array) return []

  return array.map(item => ({ id: uuid(), value: item }))
}
